import { dateTimeToDate } from "@/helpers";
import { OesStepGet } from "@/repositories/GeneratedClients";
import { MutationTree } from "vuex";
import * as mutationTypes from "./mutations-types";
import { IOesState } from "./state";

export const mutations: MutationTree<IOesState> = {
    [mutationTypes.SET_OES_STEPS]: (state, payload: OesStepGet[]) => {
        state.steps = payload.map(step => ({
            ...step,
            endDate: dateTimeToDate(step.endDate),
            startDate: dateTimeToDate(step.startDate),
        })).sort((stepA, stepB) => (stepA.isMidYearReview ? 1 : 0) - (stepB.isMidYearReview ? 1 : 0) || stepA.order - stepB.order);
    },

    [mutationTypes.SET_OES_STEPS_PROMISE]: (state, payload: Promise<OesStepGet[]> | null) => {
        state.stepsPromise = payload;
    },
};
